import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchChatUsers,
  getChatTemplate,
  updateChatUsersLoading,
  updatePagination,
} from "@/reducers/chat";

const Chat = () => {
  const dispatch = useDispatch();

  const { isChatOpen, pagination } = useSelector((state) => state.chat);
  const [moreOptionOpen, setMoreOptionOpen] = useState(false);

  useEffect(() => {
    if (isChatOpen) {
      dispatch(getChatTemplate());
      dispatch(updateChatUsersLoading(true));
      dispatch(
        updatePagination({
          ...pagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(fetchChatUsers());
    } else {
      setMoreOptionOpen(false);
    }
  }, [isChatOpen]);

  return (
    <div className="Chat_Wrapper fixed bottom-0 right-[40px] z-[1031] w-auto"></div>
  );
};

export default Chat;
